<template>
  <div class="container mescroll-touch">
    <div @click="jump(item.LinkUrl, item.Id)" class="row" v-for="(item, index) in list" :key="index">
      <img :src="item.Cover" class="img" />
      <div class="listtext">{{ item.Title }}</div>
    </div>
    <!-- <div @click="jumpccds" class="row">
      <img src="../../assets/images/listccds.png" class="img" />
      <div class="listtext">CCDS第四届中国皮肤外科大会</div>
    </div> -->
  </div>
</template>

<script>
import mixin from "../../common/mixin/mixins";
export default {
  name: "dahuilist",
  data() {
    return {
      list: {},
    };
  },
  mixins: [mixin],
  components: {},
  created() {
    this.getimg();
    this.initShare();
    document.title = "华肤荟";
  },
  methods: {
    jump(url, Id) {
      // this.$router.push("/acmed");
      this.$axios
        .post("/api/api/web/BuriedPoint/AddBP", {
          BPType: 2,
          Name: '自定义大会',
          TCode: 'custom_activity',
          Rid: Id
        }).then(res => {
          window.location.href = url + "?Id=" + Id
        })
    },
    getimg() {
      let that = this;
      this.$axios
        .post("/api/api/web/Activity/ActivityList")
        .then((res) => {
          // console.log(res)
          that.list = res.Data
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  background: rgb(228, 236, 255);
  position: relative;
}

.row {
  padding: 0.2rem 0;
  border-bottom: 1px solid #003bb9;
}

.img {
  display: block;
  width: 95%;
  margin: auto;
  border-radius: 12px;
}

.listtext {
  background-image: linear-gradient(to right, #003583, #003bb9);
  color: #fff;
  width: 95%;
  margin: auto;
  margin-top: 0.2rem;
  padding: 0.1rem 0.3rem;
  text-align: center;
  border-radius: 0.1rem;
  box-sizing: border-box;
}
</style>